import { getCompanyTypes } from "../../api/SelectApi";
import InputSelect from "../InputSelect";
import { tr } from "../../i18n";

const SelectCompanyType = (props) => {
  const data = {
    name: "company_type",
    placeholder: tr("shared:select_company_type"),
    rules: props.rules,
    className: props.className,
    defaultValue: props.defaultValue,
  };

  async function handleData(search = "") {
    const result = await getCompanyTypes(search);
    return result.data.map((d) => ({
      label: d.text,
      value: d.id,
    }));
  }

  return (
    <InputSelect props={props} data={data} handleOnLoadData={handleData} />
  );
};

export default SelectCompanyType;
